export default __webpack_public_path__ + "static/media/showMore.2ec67746.svg";